module.exports = __webpack_public_path__ + "img/05.6aa0e777.jpg";